import React from 'react';

const HelpProgressBar = ({ current, total }) => {
    const percentage = ((current + 1) / total) * 100;

    return (
        <div className="w-full h-1 bg-gray-200 dark:bg-white/10 rounded-full overflow-hidden">
            <div
                className="h-full bg-gradient-to-r from-blue-500 to-blue-600 dark:from-blue-400 dark:to-blue-500 rounded-full transition-all duration-500 ease-out"
                style={{ width: `${percentage}%` }}
            />
        </div>
    );
};

export default HelpProgressBar;
